module.exports = __webpack_public_path__ + "img/lv17.7769ab31.png";